import {useEffect, useState} from "react"
import {getCookieConsentValue} from "react-cookie-consent";

export interface DimensionsValues {
    controlsH: number;
    liveBadgeH: number;
    bannerH: number;
    width: number;
    height: number;
    minH: number;
    minW: number;
}

export const useDimensions = () => {
    const getParentContainer = () => {
        // Check if we're in an iframe
        const isInIframe = window.self !== window.top;

        if (isInIframe) {
            // If in iframe, use the iframe's dimensions
            return {
                width: window.innerWidth,
                height: window.innerHeight
            };
        }

        // Otherwise, try to get the container element
        const container = document.getElementById('atunwa-player');
        if (container) {
            const node = container.parentNode ?? container;
            if (node instanceof HTMLElement)
                return node.getBoundingClientRect();
        }

        // If no container found, use window dimensions
        return {
            width: window.innerWidth,
            height: window.innerHeight
        };
    };

    const consent = getCookieConsentValue();

    const controlsH = 65;
    const liveBadgeH = 55;
    const bannerH = 300;
    // const bannerH = consent === undefined ? 600 : 400;

    const minW: number = 320; //minimum mobile device, (iphone 5)
    const minH: number = bannerH + controlsH;

    const [w, setW] = useState<number>(minW);
    const [h, setH] = useState<number>(minH);


    const handleResize = () => {
        const newParentContainer = getParentContainer();
        if (newParentContainer) {
            const parentW = newParentContainer.width;
            const parentH = newParentContainer.height;

            // Always use parent container dimensions when they are larger than minimum requirements
            // This ensures the player fits the container even when it's larger than needed
            const adjustW = Math.max(parentW, minW);
            const adjustH = Math.max(parentH, minH);

            setW(adjustW);
            setH(adjustH);
        }
    };

    useEffect(() => {
        window.addEventListener("resize", handleResize);
        handleResize(); // Initial call on load

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return {
        controlsH,
        liveBadgeH,
        bannerH: h - controlsH,
        width: w,
        height: h,
        minH,
        minW,
    } as DimensionsValues;
};